export const API_PORT = '4000'
export const API_URL = `http://localhost:${API_PORT}`
export const DOMAIN_TITLE = 'http://djmelodie.com/'
export const IG_URL = 'https://api.instagram.com/v1/users/self/media/recent/?access_token='
export const MEL_IG = 'https://www.instagram.com/djmelodie/'




// WEBPACK FOOTER //
// ./src/.env.js